<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {provide} from 'vue';
    import {NuxtPage} from '#components';
    import {
        use3rdParties,
        useAsyncData,
        useHead,
        useHostSettings,
        useHTMLAttrsLang,
        useScripts,
        usePrismicPreviewScript,
        usePrismicClient,
    } from '#imports';
    import {PRISMIC_CLIENT} from '~/keys';

    usePrismicPreviewScript();
    const client = usePrismicClient();
    provide(PRISMIC_CLIENT, client);

    use3rdParties();
    useHTMLAttrsLang();

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }
</script>
